export default "__VITE_ASSET__oqJKsy_a__"